<template>
  <div>
    <div class="container about-job">
      <div class="test">
        <div class="top-head" v-bind:class="{ aplcnts: showApplicants }">
          <div v-if="showApplicants" class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 groupy">
              <div class="btn-group" role="group">
                <button
                  v-bind:class="{ active: tab === 'all' }"
                  @click="switchSearcFromTab('all')"
                  type="button"
                  class="btn btn-list"
                >
                  <v-icon
                    class="ico"
                    v-bind:class="{ activeIcon: tab === 'all' }"
                    >mdi-account-group</v-icon
                  >Applicants ({{ tot_count }})
                </button>
                <button
                  v-bind:class="{ active: tab === 'fav' }"
                  @click="switchSearcFromTab('fav')"
                  type="button"
                  class="btn btn-list"
                >
                  <v-icon
                    class="ico"
                    v-bind:class="{ activeIcon: tab === 'fav' }"
                    >favorite_outline</v-icon
                  >Short Listed ({{ fav_count }})
                </button>
                <button
                  v-bind:class="{ active: tab === 'rjct' }"
                  @click="switchSearcFromTab('rjct')"
                  type="button"
                  class="btn btn-list"
                >
                  <v-icon
                    class="ico"
                    v-bind:class="{ activeIcon: tab === 'rjct' }"
                    >delete_outline</v-icon
                  >Rejected ({{ rej_count }})
                </button>
                <button
                  v-bind:class="{ active: tab === 'dtls' }"
                  @click="changeContent('dtls')"
                  type="button"
                  class="btn btn-list"
                >
                  <v-icon
                    class="ico"
                    v-bind:class="{ activeIcon: tab === 'dtls' }"
                    >list_alt</v-icon
                  >Details
                </button>
              </div>

              <div
                v-if="showFilter"
                class="dropdown"
                @click="filterOpen"
                style="
                  box-shadow: 0px 0.1rem 2rem rgba(0, 0, 0, 0.1);
                  right: 2rem;
                  padding: 1rem 2rem;
                  background-color: #ffe2bd !important;
                  border-radius: 0.4rem;
                  color: grey;
                "
              >
                Filter
                <v-icon class="ico" style="padding: 0">arrow_drop_down</v-icon>
              </div>
              <div
                class="menu-box"
                v-if="drawer"
                style="
                  top: 3.2rem;
                  right: 2rem;
                  padding: 2rem;
                  max-height: 50rem;
                  overflow: scroll;
                "
              >
                <div class="row">
                  <div style="margin-right: 2rem; width: 35rem">
                    <v-select
                      :disabled="!institutions"
                      v-model="institution_name"
                      :items="institutions"
                      :multiple="true"
                      item-text="display_name"
                      item-value="name"
                      label="Institution Name"
                    ></v-select>
                    <v-select
                      :disabled="!degrees"
                      v-model="degree_name"
                      :items="degrees"
                      :multiple="true"
                      label="Degree Name"
                      item-text="display_name"
                      item-value="name"
                    ></v-select>
                    <v-select
                      :disabled="!majors"
                      v-model="major_name"
                      :items="majors"
                      :multiple="true"
                      label="Major Name"
                      item-text="display_name"
                      item-value="name"
                    ></v-select>
                  </div>
                  <div style="margin-right: 2rem; width: 35rem">
                    <v-select
                      :disabled="!experiences"
                      v-model="experience"
                      :items="experiences"
                      :multiple="true"
                      label="Year of experience"
                      item-text="display_name"
                      item-value="name"
                    ></v-select>
                    <v-select
                      :disabled="!scores"
                      v-model="score_item"
                      :items="scores"
                      :multiple="true"
                      item-text="display_name"
                      item-value="name"
                      label="Score (%)"
                    ></v-select>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="btn btn-save-new"
                    style="margin-right: 1rem"
                    @click="pre_apply_filter"
                  >
                    Apply filter
                  </div>
                  <div
                    class="btn btn-close"
                    style="margin-right: 1rem"
                    @click="clear_filter"
                  >
                    Clear filter
                  </div>
                  <div class="btn btn-cancel" @click="drawer = false">
                    Cancel
                  </div>
                </div>
              </div>
              <div
                class="dropdown-wrapper"
                style="background-color: rgba(0, 0, 0, 0.2)"
                v-if="drawer"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="middle" v-if="viewDetails">
        <job-details-card
          :key="change"
          v-bind:company_id="company_id"
          v-bind:job="detailsObj"
          v-on:edit-job="editJob"
          v-on:close-job="closeJob"
          v-on:publish-job="publishJob"
        ></job-details-card>
      </div>
      <div class="middle" v-else>
        <div
          v-if="progLoad"
          style="
            height: 90vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
          "
        >
          <!--<div class="mx-auto loader"></div>-->
          <loader></loader>
        </div>
        <div v-if="!progLoad" class="ttl-job">
          <div style="padding: 1rem">{{ job.job_title }}</div>
        </div>
        <div
          class="row filter-box"
          v-if="
            institution_name_temp.length > 0 ||
            major_name_temp.length > 0 ||
            degree_name_temp.length > 0 ||
            experience_temp.length > 0 ||
            score_item_temp.length > 0
          "
        >
          <v-icon
            style="
              position: absolute;
              right: 0.5rem;
              top: 0.5rem;
              cursor: pointer;
            "
            @click="clear_filter"
            >close</v-icon
          >
          <div
            v-for="(value, i) in institution_name_temp"
            :key="value"
            class="filter-capsule"
          >
            {{ value.length > 18 ? value.substring(0, 18) + "..." : value }}
            <v-icon class="close-capsule" @click="remove_capsule(0, i)"
              >mdi-close-circle</v-icon
            >
          </div>
          <div
            v-for="(value, i) in degree_name_temp"
            :key="value"
            class="filter-capsule"
          >
            {{ value.length > 18 ? value.substring(0, 18) + "..." : value }}
            <v-icon class="close-capsule" @click="remove_capsule(1, i)"
              >mdi-close-circle</v-icon
            >
          </div>
          <div
            v-for="(value, i) in major_name_temp"
            :key="value"
            class="filter-capsule"
          >
            {{ value.length > 18 ? value.substring(0, 18) + "..." : value }}
            <v-icon class="close-capsule" @click="remove_capsule(2, i)"
              >mdi-close-circle</v-icon
            >
          </div>
          <div
            v-for="(value, i) in experience_temp"
            :key="value"
            class="filter-capsule"
          >
            {{
              value.length > 18
                ? value.substring(0, 18) + "..."
                : value > 1
                ? `${value} years`
                : `${value} year`
            }}
            <v-icon class="close-capsule" @click="remove_capsule(3, i)"
              >mdi-close-circle</v-icon
            >
          </div>
          <div
            v-for="(value, i) in score_item_temp"
            :key="value"
            class="filter-capsule"
          >
            {{
              value.length > 18 ? value.substring(0, 18) + "..." : value + " %"
            }}
            <v-icon class="close-capsule" @click="remove_capsule(4, i)"
              >mdi-close-circle</v-icon
            >
          </div>
        </div>
        <div
          v-if="!noData && !progLoad"
          style="padding-top: 0.5rem; padding-bottom: 4rem"
        >
          <applicants-list
            :key="change"
            v-bind:type="tab"
            v-bind:job_id="currentJobID"
            v-bind:job="detailsObj"
            v-bind:company_id="company_id"
            v-bind:candidates="applicants"
            v-on:fetch-candidates="switchSearcFromTab"
            v-on:update-count="updateCount"
          ></applicants-list>
          <div class="loadMore-wrapper">
            <div @click="loadMoreApplicants" v-if="loadMore">
              <span v-if="!loading" class="loadMore">Load More</span>
              <v-progress-circular
                v-else
                :size="20"
                :width="2"
                color="#ff7722"
                indeterminate
              ></v-progress-circular>
            </div>
          </div>
        </div>
        <div
          style="
            position: absolute;
            bottom: 1rem;
            right: 0;
            z-index: 0;
            background-color: #fafafa;
            width: 100%;
          "
          v-if="page_count > 1"
        >
          <v-pagination
            v-model="pagination_page"
            :length="page_count"
            total-visible="7"
            @input="pagination"
          ></v-pagination>
        </div>
        <div class="row no-padding" v-if="noData && errMsg">
          <div class="mx-auto my-auto no-result">
            <img
              class="no-result-image"
              src="@/assets/newDesign/no-candidate.svg"
            />
            <div class="no-result-color">
              <b>{{ errMsg }}</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JobDetailsCard from "./job-details-card";
import ApplicantsList from "./applicant-list";
import Loader from "../../global-components/loader";
import {
  GET_ALL_APPLICANTS,
  GET_TYPED_APPLICANTS,
  GET_FILTER_DATA,
  FILTER_ACTION,
} from "../../../Api/employer_api";
import { isNull } from "util";
import { IsEmptyObject } from "../../../globalFunctions";
export default {
  name: "job-details",
  components: {
    JobDetailsCard,
    ApplicantsList,
    Loader,
  },
  props: {
    job: Object,
    page: String,
    company_id: String,
  },
  data: function () {
    return {
      progLoad: false,
      viewDetails: false,
      showApplicants: false,
      arrow: "fa-caret-right",
      buttonText: "Job Details",
      detailsObj: null,
      currentJobID: null,
      change: 0,
      color: "#ffffff",
      applicants: [],
      tab: "all",
      noData: false,
      errMsg: null,
      lastKey: null,
      loading: false,
      filter_offset: 0,
      page_count: 0,
      pagination_page: 0,
      totalCount: null,
      drawer: null,
      institutions: null,
      degrees: null,
      scores: null,
      experiences: null,
      majors: null,
      institution_name: [],
      major_name: [],
      degree_name: [],
      experience: [],
      score_item: [],
      institution_name_temp: [],
      major_name_temp: [],
      degree_name_temp: [],
      experience_temp: [],
      score_item_temp: [],
      filter_string: "",
      items: [
        {
          name: 1,
          display_name: "1 year (1 person)",
        },
      ],
      typed_offset: 0,
      loadMore: false,
      showFilter: false,
      tot_count: 0,
      fav_count: 0,
      rej_count: 0,
      filter_on: false,
    };
  },
  methods: {
    pre_apply_filter() {
      const self = this;
      self.pagination_page = 1;
      self.apply_filter();
    },
    updateCount(action, type) {
      const self = this;
      if (action === "add") {
        self.tot_count--;
        if (type === "fav") {
          self.fav_count++;
        } else if (type === "rej") {
          self.rej_count++;
        }
      } else if (action === "rem") {
        self.tot_count++;
        if (type === "fav") {
          self.fav_count--;
        } else if (type === "rej") {
          self.rej_count--;
        }
      }
    },
    filterOpen() {
      const self = this;
      self.drawer = !self.drawer;
      if (self.drawer) {
        let info = {
          job_id: self.job.job_id,
        };
        if (self.company_id) {
          info.company_id = self.company_id;
        }
        GET_FILTER_DATA(info)
          .then((response) => {
            if (Object.keys(response).length === 0){
              self.institutions=null;
              self.degrees=null
              self.majors=null
              self.scores=null
              self.experiences=null
            }
            else {
              self.institutions = response.filter_options[11]
                ? response.filter_options[11]
                : null;
              self.degrees = response.filter_options[12]
                ? response.filter_options[12]
                : null;
              self.majors = response.filter_options[19]
                ? response.filter_options[19]
                : null;
              self.scores = response.filter_options[38]
                ? response.filter_options[38]
                : null;
              self.experiences = response.filter_options[39]
                ? response.filter_options[39]
                : null;
            }
            if (self.scores.length>1) {
              self.scores.sort((a, b) => (parseInt(a.name, 10) < parseInt(b.name, 10)) ? 1 : -1)
            }
          })
          .catch((err) => {});
      }
    },
    resetReq() {
      const self = this;
      self.lastKey = null;
      self.typed_offset = 0;
      self.noData = false;
      self.errMsg = null;
      self.loadMore = false;
      self.institution_name_temp = [];
      self.major_name_temp = [];
      self.degree_name_temp = [];
      self.experience_temp = [];
      self.score_item_temp = [];
      self.applicants = [];
      self.filter_on = false;
    },
    clear_filter() {
      const self = this;
      (self.institution_name = null),
        (self.major_name = null),
        (self.degree_name = null),
        (self.experience = null),
        (self.score_item = this.null),
        self.switchSearcFromTab("all", true);
      self.drawer = false;
      self.filter_on = false;
    },
    remove_capsule(param, index) {
      const self = this;
      if (param === 0) {
        self.institution_name_temp.splice(index, 1);
        self.institution_name = self.institution_name_temp;
      }
      if (param === 1) {
        self.degree_name_temp.splice(index, 1);
        self.degree_name = self.degree_name_temp;
      }
      if (param === 2) {
        self.major_name_temp.splice(index, 1);
        self.major_name = self.major_name_temp;
      }
      if (param === 3) {
        self.experience_temp.splice(index, 1);
        self.experience = self.experience_temp;
      }
      if (param === 4) {
        self.score_item_temp.splice(index, 1);
        self.score_item = self.score_item_temp;
      }
      if (
        self.institution_name_temp.length > 0 ||
        self.degree_name_temp.length > 0 ||
        self.major_name_temp.length > 0 ||
        self.experience_temp.length > 0 ||
        self.score_item_temp.length > 0
      ) {
        self.apply_filter();
      } else {
        self.clear_filter();
      }
    },
    filter_action(params) {
      const self = this;
      self.applicants = [];
      FILTER_ACTION(
        params,
        self.filter_offset,
        self.currentJobID,
        self.company_id
      )
        .then((response) => {
          if (response.status === this.$constants.RESPONSE_CODE.PROCESSING) {
            self.filter_action(params);
          } else {
            if (response.data.candidates && response.data.count > 0) {
              self.applicants = response.data.candidates;
              self.page_count = Math.ceil(response.data.count / 10);
              self.noData = false;
              self.tot_count = response.data.count;
              self.change++;
              self.drawer = false;
            } else {
              self.change++;
              self.drawer = false;
              self.noData = true;
              self.errMsg =
                response.data.message ||
                "No Applicant has applied for this job";
            }
          }
          self.drawer = false;
        })
        .catch();
    },
    apply_filter() {
      const self = this;
      let params = {};
      self.filter_on = true;
      if (self.institution_name && self.institution_name.length > 0) {
        params[11] = self.institution_name;
        self.institution_name_temp = self.institution_name;
      }
      if (self.degree_name && self.degree_name.length > 0) {
        params[12] = self.degree_name;
        self.degree_name_temp = self.degree_name;
      }
      if (self.major_name && self.major_name.length > 0) {
        params[19] = self.major_name;
        self.major_name_temp = self.major_name;
      }
      if (self.score_item && self.score_item.length > 0) {
        params[38] = self.score_item;
        self.score_item_temp = self.score_item;
      }
      if (self.experience && self.experience.length > 0) {
        params[39] = self.experience;
        self.experience_temp = self.experience;
      }
      if (!IsEmptyObject(params)) {
        self.lastKey = null;
        self.typed_offset = 0;
        self.noData = false;
        self.errMsg = null;
        self.loadMore = false;
        self.filter_action(params);
      }
    },
    pagination() {
      const self = this;
      self.filter_offset = (self.pagination_page - 1) * 10;
      self.apply_filter();
    },
    switchSearcFromTab(tab, force) {
      const self = this;
      self.filter_offset = 0;
      self.page_count = 0;
      self.pagination_page = 0;
      self.progLoad = true;
      self.applicants = [];
      if (force || tab !== self.tab || self.filter_on) {
        self.resetReq();
        self.tab = tab;
      }
      if (self.tab === "all") {
        self.showFilter = true;
        self.getAllApplicants();
      } else {
        let action;
        self.showFilter = false;
        if (self.tab === "fav") {
          action = "favorite";
        }
        if (self.tab === "rjct") {
          action = "rejected";
        }
        self.getFavouriteApplicants(action);
      }
    },
    loadMoreApplicants() {
      const self = this;
      self.loading = true;
      if (self.tab === "all") {
        self.showFilter = true;
        self.getAllApplicants();
      } else {
        let action;
        self.showFilter = false;
        if (self.tab === "fav") {
          action = "favorite";
        }
        if (self.tab === "rjct") {
          action = "rejected";
        }
        self.getFavouriteApplicants(action);
      }
    },
    compare(a, b) {
      const A = a.score_flat;
      const B = b.score_flat;

      let comparison = 0;
      if (A > B) {
        comparison = -1;
      } else if (A < B) {
        comparison = 1;
      }
      return comparison;
    },
    getAllApplicants() {
      const self = this;
      self.viewDetails = false;
      let params = {
        user_id: self.detailsObj.user_id,
        job_id: self.detailsObj.job_id,
        last_evaluated_key: self.lastKey,
      };
      if (self.company_id) {
        params.company_id = self.company_id;
      }
      GET_ALL_APPLICANTS(params)
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.candidates.length > 0) {
              let temp = response.data.candidates;
              let candidates = temp.sort(self.compare);
              for (let i = 0; i < candidates.length; i++) {
                self.applicants.push(candidates[i]);
              }
              if (response.data.last_evaluated_key) {
                self.lastKey = response.data.last_evaluated_key;
                self.loadMore = true;
              } else {
                self.lastKey = null;
                self.loadMore = false;
              }
              self.noData = false;
            } else {
              self.change++;
              self.noData = true;
              self.loadMore = false;
              self.lastKey = null;
              self.errMsg =
                response.data.message ||
                "No Applicant has applied for this job";
            }
            self.tot_count = response.data.count;
            self.fav_count = response.data.fav_count;
            self.rej_count = response.data.rej_count;
          } else {
            self.change++;
            self.noData = true;
            self.loadMore = false;
            self.lastKey = null;
            self.errMsg = "No Applicant has applied for this job";
          }
          self.progLoad = false;
          self.loading = false;
        })
        .catch(function (err) {
          self.progLoad = false;
          self.loading = false;
          self.change++;
          self.errMsg = err.message;
        });
    },
    getFavouriteApplicants(action) {
      const self = this;
      self.viewDetails = false;
      let params = {
        user_id: self.detailsObj.user_id,
        job_id: self.detailsObj.job_id,
        action_type: action,
        last_evaluated_key: self.lastKey,
      };
      if (self.company_id) {
        params.company_id = self.company_id;
      }
      // offset not used anymore. we use last_evaluated_key
      // if (self.typed_offset > 0) {
      //   params.offset = self.typed_offset;
      // }
      GET_TYPED_APPLICANTS(params)
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.candidates.length > 0) {
              let temp = response.data.candidates;
              let candidates = temp.sort(self.compare);
              for (let i = 0; i < candidates.length; i++) {
                self.applicants.push(candidates[i]);
              }
              self.totalCount = response.data.count;
              self.typed_offset += 10;
              self.noData = false;
              if (response.data.last_evaluated_key) {
                self.lastKey = response.data.last_evaluated_key;
                self.loadMore = true;
              } else {
                self.lastKey = null;
                self.loadMore = false;
              }
              self.rej_count = response.data.rej_count;
              self.fav_count = response.data.fav_count;
            } else {
              self.change++;
              self.noData = true;
              self.loadMore = false;
              self.lastKey = null;
              self.errMsg = "No applicants in this criteria";
            }
            // if (action === "rejected") {
            //   self.rej_count = response.data.rej_count;
            // } else {
            //   self.fav_count = response.data.fav_count;
            // }
          } else {
            self.change++;
            self.noData = true;
            self.loadMore = false;
            self.lastKey = null;
            self.errMsg =
              "Something went wrong. Please try again after sometime.";
          }
          self.progLoad = false;
          self.loading = false;
        })
        .catch(function (err) {
          self.change++;
          self.progLoad = false;
          self.loading = false;
          self.noData = true;
          self.loadMore = false;
          self.change++;
          self.errMsg = err.message;
        });
    },
    changeContent(tab) {
      const self = this;
      self.viewDetails = true;
      self.tab = tab;
    },
    editJob(job) {
      this.$emit("edit-job", job);
    },
    closeJob() {
      this.$emit("close-job");
    },
    publishJob() {
      this.$emit("publish");
    },
  },
  mounted: function () {
    const self = this;
    if (self.job) {
      self.detailsObj = self.job;
      self.detailsObj.page = self.page;
      self.currentJobID = self.job.job_id;
      switch (self.page) {
        case "active":
          self.viewDetails = false;
          self.showApplicants = true;
          self.switchSearcFromTab("all");
          break;
        case "pending":
          self.viewDetails = true;
          self.showApplicants = false;
          break;
        case "draft":
          self.viewDetails = true;
          self.showApplicants = false;
          break;
        case "expired":
          self.tab = "all";
          self.viewDetails = false;
          self.showApplicants = true;
          self.switchSearcFromTab("all");
          break;
        default:
          self.viewDetails = true;
          self.showApplicants = false;
      }
      self.change++;
    }
  },
};
</script>

<style scoped>
.filter-box {
  background-color: #fafafa;
  padding: 1.5rem;
  padding-top: 0.5rem;
  position: relative;
  margin-top: 1rem;
}
.close-capsule {
  cursor: pointer !important;
  margin-left: 0.2rem;
}
.filter-capsule {
  padding: 0.5rem 2rem;
  max-width: 22rem;
  border-radius: 2rem;
  margin: 1rem 1rem 0 0;
  background-color: var(--synop-select-color);
}
.loading {
  height: 90vh;
  padding: 30vh 0;
}
.about-job {
  background-color: white;
}
.test {
  position: relative;
}
.top-head {
  height: 4.8rem;
  /*background-color: white;*/
  padding: 0;
  position: absolute;
  top: 0;
  z-index: 2;
  width: 100%;
  background-color: #fafafa;
}
.aplcnts {
  background-color: #ffffff;
}
.ttl-job {
  margin-top: 4rem;
  text-align: left;
  font-weight: bold;
  font-size: 2rem;
  padding-top: 0.5rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  border-left: 0.3rem solid var(--job-select-color);
}
.middle {
  height: 90vh;
  overflow: auto;
}
.groupy {
  text-align: left;
  padding: 0;
}
.buttOn {
  padding: 1rem;
}
.header-text {
  font-size: 1.6rem;
  font-weight: bold;
  text-align: left;
  padding: 1.5rem 0;
}
.btn-group {
  height: 3.5rem;
}
.btn-list {
  font-size: 1.4rem;

  text-align: center;
  color: #75798d;
  border: none;

  /* border-radius: 0; */
  box-shadow: 0rem 0rem 1.5rem rgba(0, 0, 0, 0.05);
  margin: 0 1rem 0 0.5rem;
  padding: 0 2rem;
}
.btn-list:hover {
  color: var(--link-color);
}
.ico {
  color: #a2a5b9;
  font-size: 2rem;
  padding-right: 0.5rem;
}
.btn-list:hover .ico {
  color: var(--link-color);
}
.active {
  color: #ffffff !important;
  background-color: var(--link-color);
}
.activeIcon {
  color: #ffffff !important;
}
.no-result {
  margin-top: 5.5rem !important;
  height: 70vh;
  padding: 15vh;
}
.no-result-color {
  margin-top: 1rem;
  font-size: 2.4rem;
  color: var(--button-delete-color);
}
.no-result-image {
  width: 30rem;
}
.prog {
  margin-top: 5.5rem;
  z-index: 50;
}
.loadMore-wrapper {
  width: 100%;
  outline: none;
  padding: 2rem 0;
}
.loadMore {
  border: 0.1rem transparent;
  border-radius: 0.3rem;
  background-color: var(--button-color);
  padding: 1rem;
  color: #ffffff;
  font-size: 1.4rem;
  cursor: pointer;
}
.show-more {
  margin: 0 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 1.6rem;
  color: var(--secondary-color);
  cursor: pointer;
  text-align: right;
}
.back {
  color: var(--link-color);
  text-align: left;
}
</style>
